module.exports = __webpack_public_path__ + "static/media/INTRODUCTION TO CASE MANAGEMENT SYSTEM.5ed5b458.png";